import "../../assets/css/argon-dashboard-react.css";
import "../../assets/css/Register.css";
import React, { useEffect, useState } from 'react';
import { signupUser, loginUser, googleLogin } from "../../apiHandles/user_authentication";
import axiosInstance from "../../apiHandles/axiosInstance";
import { useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";

// ΕΞΩ ΑΠΟ ΤΟ COMPONENT
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const Register = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      setIsLoading(true);
      setError("");
      //alert("Google response: " + JSON.stringify(credentialResponse, null, 2));

      const res = await googleLogin(credentialResponse.credential);
      //alert("Backend response: " + JSON.stringify(res, null, 2));

      if (res && res.data && res.data.access) {
        localStorage.setItem("access", res.data.access);
        if (res.data.refresh) {
          localStorage.setItem("refresh", res.data.refresh);
        }
        if (res.data.username) {
          localStorage.setItem("username", res.data.username);
        }
        navigate("/HomePage/homepage");
      } else {
        //alert("Invalid response format: " + JSON.stringify(res, null, 2));
        setIsLoading(false);
        setError("Google signup failed");
      }
    } catch (err) {
      console.error("Google signup error:", err);
      //alert("Error details: " + JSON.stringify(err, null, 2));
      setError("Google signup failed. Please try again.");
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    setError("Google signup was unsuccessful. Please try again.");
  };

  const handleSignup = async () => {
    try {
      setIsLoading(true);
      setError("");
      const res = await signupUser({
        username: username,
        email: email,
        password: password,
      });

      // Μετά το επιτυχημένο register, κάνε αυτόματο login
      try {
        const loginRes = await loginUser(username, password);
        if (loginRes.data && loginRes.data.access && loginRes.data.refresh) {
          localStorage.setItem("access", loginRes.data.access);
          localStorage.setItem("refresh", loginRes.data.refresh);
          localStorage.setItem("username", username);
        }
      } catch (loginError) {
        setError("Registration successful, but auto-login failed. Please login manually.");
        setIsLoading(false);
        return;
      }

      setUsername("");
      setEmail("");
      setPassword("");
      navigate("/HomePage/homepage");

    } catch (err) {
      if (err.response && err.response.data) {
        const data = err.response.data;
        setError(data.error || data.detail || data.message || "Signup failed. Please fill all the fields correctly.");
      } else if (err.message) {
        setError(err.message);
      } else {
        setError("Signup failed. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => { setError("") }, 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  return (
    <div className="registerMainBackground">
      <Card className="registerCard">
        <CardHeader
          className="register-card-header"
          style={{
            background: "transparent",
            textAlign: "center",
            paddingBottom: "3%",
            marginBottom: "-5%"
          }}
        >
          {/* Modern Header */}
          <div style={{ marginBottom: "3%" }}>
            <p style={{
              color: "#d0d4daff",
              fontSize: "1rem",
              fontWeight: "400",
              paddingTop: "10px"
            }}>
              Create Your Account <br />Join us and start your journey
            </p>
          </div>

          {/* Google Sign Up Button */}
          <div
            className="google-register-container"
            style={{ borderRadius: "20px", width: "100%" }}
          >
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              size="large"
              text="signup_with"
            />
          </div>

          <br></br>

          {/* Modern Divider */}
          <div style={{ position: "relative", marginBottom: "5vh" }}>
            <div
              style={{
                position: "absolute",
                inset: "0",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{
                width: "100%",
                height: "1px",
                background: "linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.6), transparent)"
              }}></div>
            </div>
            <div style={{
              position: "relative",
              display: "flex",
              justifyContent: "center"
            }}>
              <span
                style={{
                  background: "rgba(30, 41, 59, 0.9)",
                  color: "#94a3b8",
                  fontSize: "0.875rem",
                  fontWeight: "500",
                  backdropFilter: "blur(10px)",
                  padding: "0 10px"
                }}
              >
                Or sign up with credentials
              </span>
            </div>
          </div>
          <br />
        </CardHeader>

        <CardBody>
          <Form role="form" onSubmit={e => { e.preventDefault(); handleSignup(); }}>
            <FormGroup className="register-first-form-group">
              <label className="registerLabel">
                Username
              </label>
              <InputGroup
                className="registerInputField"
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = "rgba(59, 130, 246, 0.6)";
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = "rgba(71, 85, 105, 0.4)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.background = "rgba(51, 65, 85, 0.6)";
                }}
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#94a3b8",
                      padding: "0 16px"
                    }}
                  >
                    <i className="ni ni-hat-3" style={{ fontSize: "18px" }} />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Your username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "white",
                    fontSize: "1rem",
                    padding: "16px 12px",
                    fontWeight: "500",
                    letterSpacing: "0.025em"
                  }}
                />
              </InputGroup>
            </FormGroup>

            <FormGroup className="mb-4">
              <label className="registerLabel">
                Email
              </label>
              <InputGroup
                className="registerInputField"
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = "rgba(59, 130, 246, 0.6)";
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = "rgba(71, 85, 105, 0.4)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.background = "rgba(51, 65, 85, 0.6)";
                }}
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#94a3b8",
                      padding: "0 16px"
                    }}
                  >
                    <i className="ni ni-email-83" style={{ fontSize: "18px" }} />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Your email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "white",
                    fontSize: "1rem",
                    padding: "16px 12px",
                    fontWeight: "500",
                    letterSpacing: "0.025em"
                  }}
                />
              </InputGroup>
            </FormGroup>

            <FormGroup className="mb-4">
              <label className="registerLabel">
                Password
                <span className="passwordTooltipWrapper">
                  <span className="tooltipIcon">?</span>
                  <div className="tooltipBox">
                    <p className="passwordInfo">Password must contain:</p>
                    <ul>
                      <li>At least 2 lowercase letters</li>
                      <li>At least 1 uppercase letter</li>
                      <li>At least 1 special character (!@#$...)</li>
                      <li>At least 1 number</li>
                      <li>Minimum 8 characters</li>
                    </ul>
                  </div>
                </span>
              </label>
              <InputGroup
                className="registerInputField"
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = "rgba(59, 130, 246, 0.6)";
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = "rgba(71, 85, 105, 0.4)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.background = "rgba(51, 65, 85, 0.6)";
                }}
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#94a3b8",
                      padding: "0 16px"
                    }}
                  >
                    <i className="ni ni-lock-circle-open" style={{ fontSize: "18px" }} />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Your password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="new-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "white",
                    fontSize: "1rem",
                    padding: "16px 12px",
                    fontWeight: "500",
                    letterSpacing: "0.025em"
                  }}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText
                      className="loginInputText"
                      onClick={() => setShowPassword(prev => !prev)}
                      style={{ cursor: "pointer" }}
                  >
                      <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`} style={{ fontSize: "16px" }} />
                  </InputGroupText>
                </InputGroupAddon>
          </InputGroup>
              

              {error && (
                <div className="registerErrormsg">
                  <i className="ni ni-fat-remove" style={{ fontSize: "16px" }}></i>
                  {error}
                </div>
              )}
            </FormGroup>

            <div className="text-center">
              <Button
                style={{
                  color: "#fff",
                  boxShadow: "none"
                }}
                className="registerCreateAccountbtn"
                type="submit"
                disabled={isLoading}
                onMouseOver={(e) => {
                  if (!isLoading) {
                    e.target.style.transform = "translateY(-1px)";
                    e.target.style.color = "#fff"
                  }
                }}
                onMouseOut={(e) => {
                  if (!isLoading) {
                    e.target.style.transform = "translateY(0px)";
                  }
                }}
              >
                {isLoading ? (
                  <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        border: "3px solid rgba(255, 255, 255, 0.3)",
                        borderTop: "3px solid white",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                        marginRight: "12px",
                      }}
                    ></div>
                    Creating account...
                  </span>
                ) : (
                  "Create Account"
                )}
              </Button>
            </div>
          </Form>

          {/* Sign In Link */}
          <div className="alreadyHaveAccoutnDiv">
            <p className="alreadyHaveAccoutnText">
              Already have an account?  {" "}
              <a
                href="#pablo"
                onClick={() => navigate("/auth/login")}
                style={{
                  color: "#60a5fa",
                  fontWeight: "700",
                  textDecoration: "none",
                  transition: "all 0.2s ease",
                  backgroundImage: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent"
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundImage = "linear-gradient(135deg, #2563eb, #7c3aed)";
                  e.target.style.transform = "translateY(-1px)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundImage = "linear-gradient(135deg, #3b82f6, #8b5cf6)";
                  e.target.style.transform = "translateY(0px)";
                }}
              >
                {" "}  Sign in
              </a>
            </p>
          </div>
        </CardBody>
      </Card>

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        input::placeholder {
          color: #94a3b8 !important;
          opacity: 1 !important;
        }
        
        input::-webkit-input-placeholder {
          color: #94a3b8 !important;
          opacity: 1 !important;
        }
        
        input::-moz-placeholder {
          color: #94a3b8 !important;
          opacity: 1 !important;
        }
        
        input:-ms-input-placeholder {
          color: #94a3b8 !important;
          opacity: 1 !important;
        }
      `}</style>
    </div>
  );
};

// Wrapper component με GoogleOAuthProvider
const RegisterWithProvider = () => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Register />
    </GoogleOAuthProvider>
  );
};

export default RegisterWithProvider;